module.exports = __webpack_public_path__ + "img/terroir-liquify-3.ae363a7d.jpg";